module.exports = require('./helpers/bundle-url').getBundleURL('8kqgc') + "health-insurance-card-no.789782af.png";